export { MailMagazineSettingsTemplate } from './MailMagazineSettingsTemplate';
